import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            实时快讯
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            综艺圈最新动态，热门综艺资讯第一时间送达
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2 hidden md:block"></div>

          <div className="space-y-6 md:space-y-10">
            {updatesData.map((item, idx) => (
              <div
                key={item.id}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>

                <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <span className="text-xs text-foreground-400">{item.date}</span>
                      <span
                        className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                          item.tag === '热播' || item.tag === '热门'
                            ? 'bg-primary-100 text-primary-700'
                            : item.tag === '上新'
                            ? 'bg-accent-100 text-accent-700'
                            : 'bg-secondary-100 text-secondary-700'
                        }`}
                      >
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.summary}
                    </p>
                  </div>
                </div>

                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}